//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { Form, FormItem, Input, Select, Option } from 'element-ui';
import { saveInvestorInfo } from '@/api/member';
export default {
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
  },
  data() {
    return {
      form: {
        name: null,
        type: '身份证',
        code: null,
        agree: false,
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            validator(rule, val, callback) {
              if (!val || (/^[\u4E00-\u9FA5]+$/.test(val) && val.length < 2)) {
                callback('请输入您的真实姓名');
              }
              callback();
            },
          },
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, val, callback) => {
              if (!val) {
                callback('请输入证件号');
              } else if (this.form.type === '身份证' && val.length !== 18) {
                callback('证件号码不正确');
              }
              callback();
            },
          },
        ],
      },
      select: {
        type: ['身份证', '护照', '港澳通行证', '台胞证'],
      },
    };
  },
  methods: {
    ...mapActions('user', ['updateUserInfoKyc']),
    /**
     * @description 提交验证
     */
    submit() {
      this.$refs.form.validate(async res => {
        if (res) {
          const data = await this.$axios(saveInvestorInfo());
          if (data.statusCode === 200) {
            this.updateUserInfoKyc({
              certification: true,
            });
            this.$emit('submitSuccess');
          }
        }
      });
    },
  },
};
